// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TenorCustomFromJSON, TenorCustomToJSON, TenorCustomDateRangeFromJSON, TenorCustomDateRangeToJSON, } from './';
export function TenorFromJSON(json) {
    return {
        'sinceInception': !exists(json, 'sinceInception') ? undefined : json['sinceInception'],
        'ytd': !exists(json, 'ytd') ? undefined : json['ytd'],
        'custom': !exists(json, 'custom') ? undefined : TenorCustomFromJSON(json['custom']),
        'customDateRange': !exists(json, 'customDateRange') ? undefined : TenorCustomDateRangeFromJSON(json['customDateRange']),
    };
}
export function TenorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'sinceInception': value.sinceInception,
        'ytd': value.ytd,
        'custom': TenorCustomToJSON(value.custom),
        'customDateRange': TenorCustomDateRangeToJSON(value.customDateRange),
    };
}
